const PL = {
    report: 'Raport | Raporty',
    recipient: 'Odbiorca | Odbiorcy',
    schedule: 'Harmonogram | Harmonogramy',
    generate_report: 'Generowanie Raportów',
    report_schedules: 'Harmonogram Raportów',
    reset: 'Zacznij od nowa',
    change_report: 'Zmień Raport',
    change_report_warning: 'Czy na pewno chcesz wybrać inny raport? Wszelkie niezapisane zmiany w obecnym raporcie zostaną utracone.',
    warning: 'Uwaga!',
    something_went_wrong: 'Coś poszło nie tak. Skontaktuj się z obsługą klienta celem uzyskania pomocy.',
    unexpected: 'Jeśli jest to nieoczekiwana sytuacja, skontaktuj się z obsługą klienta celem uzyskania pomocy.',
    create_schedule: 'Dodaj Harmonogram',
    create_schedule_short: 'Harmonogram',
    select_report_first: 'Wybierz raport który chcesz zapisać',
    save_as_own_report: 'Zapisz',
    show_more: 'Pokaż więcej',
    plase_wait: 'Proszę czekać...',
    gathering: 'Pobieranie danych...',
    combining: 'Łączenie danych...',
    structuring: 'Strukturyzacja danych...',
    organising: 'Organizowanie danych...',
    collecting: 'Kolekcjonowanie danych...',
    displaying: 'Prezentowanie danych...',
    historical_data: 'Dane historyczne dla',
    filters: 'Filtry',
    csv_export: 'Eksport do CSV',
    re_run: 'Zastosuj zmiany',
    no_data: 'Brak danych',
    change_filter_for_more_results: 'Dostosuj filtry aby wyświetlić więcej wyników',
    add_new_report: 'Dodaj nowy raport',
    edit_report: 'Edytuj raport',
    create_report: 'Stwórz raport',
    edit: 'Edytuj',
    export: 'Eksportuj',
    report_name: 'Nazwa raportu',
    save_report_in: 'Zapisz raport w',
    select: 'Wybierz',
    edit_schedule: 'Edytuj harmonogram',
    title: 'Tytuł',
    trigger_date: 'Czas uruchomienia',
    repeats: 'Powtórz',
    frequency: 'Powtarzaj co',
    repeating_ends: 'Zatrzymaj powtarzanie po',
    after: 'Po',
    occurences: 'powtórzeniach',
    on_date: 'W dniu',
    submit: 'Save',
    add_new: 'Dodaj nowy',
    add: 'Dodaj',
    search_add_recipient: 'Wyszukaj lub dodaj odbiorcę',
    add_recipient: 'Dodaj odbiorcę',
    remove_report: 'Usuń raport',
    can_view: 'może widzieć',
    can_edit: 'może edytować',
    enter_report_name_to_confirm_removal: 'Wpisz nazwę raportu aby potwierdzić usunięcie',
    caution_removing_report: 'UWAGA! WSZYSTKIE HARMONOGRAMY PRZYPISANE DO TEGO RAPORTU ZOSTANĄ USUNIĘTE!',
    remove: 'Usuń',
    remove_schedule: 'Usuń harmonogram',
    enter_schedule_name_to_confirm_removal: 'Wpisz nazwę harmonogramu aby potwierdzić usunięcie',
    caution_removing_schedule: `UWAGA! NIE MOŻNA COFNĄĆ TEJ OPERACJI!`,
    select_path: 'Wybierz ścieżkę',
    error_occured: 'Wystąpił błąd',
    select_report: 'Wybierz Raport',
    name: 'Nazwa',
    last_run: 'Ostatnio generowany',
    chart: 'Wykres',
    charts: 'Wykresy',
    ticket_history: 'Historia zgłoszeń',
    general_info: 'Informacje ogólne',
    map: 'Mapa',
    add_path: 'Dodaj ścieżkę',
    add_filter: 'Dodaj filtr',
    add_another_filter: 'Dodaj kolejnyh filtr',
    delete_path: 'Usuń ścieżkę',
    delete_filter: 'Usuń filtr',
    from_number: 'Od (numer)',
    to_number: 'Do (numer)',
    enter_text: 'Wpisz tekst',
    date_label: 'Data | Daty',
    date: 'Data',
    date_range: 'Zakres dat',
    number: 'Number',
    day: 'Dzień | Dni',
    run: 'Generuj',
    apply: 'Zastosuj',
    group_by: 'Grupuj po',
    stack_by: 'Kumuluj po',
    columns: 'Kolumny',
    order_by: 'Sortuj po',
    report_type: 'Typ Raportu',
    report_subtype: 'Podtyp Raportu',
    empty_here: `Trochę tutaj pusto :(`,
    no_reports_for_this_type: 'Brak raportów dla wybranego typu raportu',
    select_report_type: 'Wybierz typ raportu',
    choose_one_from_reports: 'Wybierz dostępny typ z listy po lewej stronie',
    select_report: 'Wybierz raport',
    outline: 'Schemat',
    filters: 'Filtry',
    addons: 'Dodatki',
    device_search: 'Znajdź urządzenie',
    shared_reports: 'Udostępnione raporty',
    create_shared: 'Udostepnij raport',
    create_shared_short: 'Udostepnij',
    edit_shared: 'Edytuj udostępniony raport',
    remove_shared: 'Usuń udostęonony raport',
    are_you_sure_remove: 'Czy jesteś pewny że chcesz usunąć',
    shared_report_exists: 'Podana nazwa raportu udostępnionego już istnieje',
    tooltip_report_type: 'Zaznacz typ raportu aby wybrać źródło danych',
    tooltip_report_name: 'Zaznacz nazwę raportu aby wybrac który raport chcesz wygenerować',
    tooltip_group_by: 'Wybierz tę opcję by stworzyć raport z odrębnymi grupami dla wybranej kolumny. Te same wartości będą podłączone do odpowiedniej grupy',
    tooltip_stack_by: 'Wybierz tę opcję by stworzyć skumulowany raport z odrębnymi grupami dla wybranej kolumny. Te same wartości zostaną skumulowane jako część słupka wykresu',
    tooltip_chart_rerun: 'Wygeneruj ponownie raport, aby zobaczyć efekt skumulowania danych.',
    additional_dates_grouping: 'Dodatkowe grupowanie po dacie',
    tooltip_additional_dates_grouping: 'Wybierz tę opcję by dodać grupowanie po dacie w każdej grupie stworzonej przez pole "Group By". Możesz wybrać "Rok", "Miesiąc" i "Dzień" by zmienić przedział czasu grupowania',
    aggregate: 'Agregacja danych',
    tooltip_aggregate: 'Wybierz tę opcję by dodać kolumnę zawierającą "Średnią", "Minimum", "Maksimum", "Sumę" obliczoną dla wybranej kolumny w każdej grupie stworzonej przez pole "Group By"',
    tooltip_columns: 'Wybierz wszystkie kolumny które mają pojawić się w Twoim raporcie. Kolejność wybranych kolumn przekładać się będzie na kolejność w raporcie. Możesz zostawić to pole puste aby dodać wszystkie możliwe kolumny',
    tooltip_order: 'Wybierz kolumnę według której należy posortować dane. Możesz wybrać kilka kolumn i wybrać kierunek rosnący lub malejący dla każdej kolumny',
    tooltip_datefilter: 'Wybierz typ daty i dodaj kolumnę z typem danych "Datetime" za pomocą przycisku "Dodaj filtr". Jeśli chcesz zastosować datę do tego filtra, musisz wybrać "true" z pola wyboru wybranej właściwości. Możesz także wybrać inne kolumny typów danych i ustawić odpowiednią wartość do filtrowania',
    tooltip_chart: 'Wybierz jeden z wykresów aby wyśiwetlić go powyżej wygenerowanego raportu. Po zapisaniu raportu, możesz wyświetlić ten wykres w panelu Dashboard',
    tooltip_map: 'Ustaw wartość na "Show", aby wyświetlić ostatnie lokalizacje na mapie z użyciem kolumn "latitude" i "longitude"',
    tooltip_recipients_emails: 'Wybierz wszystkich odbiorców, którym chcesz udostępnić wybrany raport. Możesz wpisać dowolny adres e-mail i wysłać raport do osoby która nie posiada aktywnego konta w serwisie TRG ServiceHub',
    tooltip_recipients: 'Wybierz wszystkich odbiorców, którym chcesz udostępnić wybrany raport. Możesz wybrać tylko użytkowników serwisu TRG ServiceHub',
    tooltip_myown_report: 'Wybierz raport których chcesz udostępnić. Pojawi się on w typie raportu "My Company reports" wybranego użytkownika. Możesz wybrać raporty które znajdują się w Twoim typie raportu "My own reports"',
    tooltip_unique_title: 'Wpisz proszę unikatowy tytuł dla udostępnionego raportu',
    tooltip_title: 'Wpisz nazwę dla nowego harmonogramu',
    tooltip_report: 'Wybierz proszę raport który ma zostać dodany do harmonogramu. Możesz wybrać dowolny raport',
    tooltip_trigger_date: 'Wybierz proszę datę rozpoczęcia harmonogramu',
    tooltip_repeats: 'Jeżeli generowanie raportu powinno być powtarzane, proszę zaznacz poniższe pole',
    tooltip_frequency: 'Wybierz jak często powtarzać generowanie raportu',
    tooltip_repeating_ends: 'Wybierz proszę kiedy harmonogram ma dobiec końca',
    my_reports: 'Moje Raporty',
    my_own_report: 'Zapisane Raporty',
    my_company_report: 'Firmowe Raporty',
    foreground_duration: 'Aplikacja w tle [czas]',
    asset_number: 'Numer urządzenia',
    battery: 'Poziom baterii [%]',
    charging: 'Stan ładowania',
    battery_usage: 'Zdrowie baterii',
    battery_status: 'Status baterii',
    battery_temperature: 'Temperatura baterii',
    battery_time_left: 'Pozostały czas baterii',
    batterySerialNumber: 'Numer seryjny baterii',
    gsm_cell_tower_id: 'Id wieży komórkowej',
    gsm_name: 'Dostawca sieci',
    gsm_signal: 'Siła sygnału mobilnego',
    gsm_type: 'Sieć [3G,4G,5G]',
    gsm_download: 'Pobieranie danych [GSM] [KB]',
    has_battery_changed: 'Bateria: Zmiana w ciągu dnia',
    has_screen_time: 'Czas używania ekranu - czas niezerowy',
    max_screen_time: 'Maks. Czas używania ekranu',
    max_screen_time_str: 'Maks. Czas używania ekranu',
    wifi_download: 'Pobieranie danych [Wi-Fi] [KB]',
    gsm_upload: 'Wysyłanie danych [GSM] [KB]',
    wifi_upload: 'Wysyłanie danych [Wi-Fi] [KB]',
    build_no: 'Numer builda',
    device_ip: 'IP urządzenia',
    manufacturer: 'Producent',
    model: 'Model urządzenia',
    latitude: 'Współrzędne - Lat',
    longitude: 'Współrzędne - Long',
    os_version: 'Wersja androida',
    screen_time: 'Czas używania ekranu',
    security_patch_date: 'Data wgrania aktualizacji',
    total_external_storage: 'Łączne zewnętrzne miejsce',
    external_storage: 'Pozostałe zewnętrzne miejsce',
    total_internal_storage: 'Łączne wewnętrzne miejsce',
    internal_storage: 'Wewnętrzne pozostałe miejsce',
    total_ram: 'Pozostały RAM',
    ram: 'Używany RAM',
    wifi_name: 'Nazwa Wi-Fi',
    wifi_signal: 'Siła sygnału Wi-Fi',
    client_id: 'Id klienta',
    package_name: 'Aplikacja',
    path: 'Ścieżka',
    version_name: 'Wersja aplikacji',
    updated_at: 'Data aktualizacji',
    created_at: 'Data utworzenia',
    bssid: 'BSSID',
    android_id: 'Android ID',
    start_date: 'Data Rozpoczęcia',
    end_date: 'Data Zakończenia',
    imei: 'IMEI',
    serial_number: 'Numer Seryjny',
    map_hidden: 'Mapa została ukryta ze względu na brak dostępnych lokalizacji',
    truncated_output: 'Wyświetlono maksymalną dostępną ilość rekordów',
    custom_1: 'Nazwa Sieci',
    custom_2: 'ID Sieci',

    asset_number__c: 'Asset Number',
    custom_attribute__c: 'Custom Attribute',
    customer_reference__c: 'Customer Reference',
    record_type_name__c: 'Record Type',
    reported_fault_category__c: 'Reported Fault Category',
    reported_fault__c: 'Reported Fault',
    accessories__c: 'Accessories',
    contact_fao__c: 'Contact Fao',
    organisation_name__c: 'Organisation Name',
    address_line_1__c: 'Address',
    address_line_2__c: 'Address',
    address_line_3__c: 'Address',
    address_line_4__c: 'Address',
    country__c: 'Country',
    postcode__c: 'Postcode',
    sitename__r: 'Site',
    shipment_notification_email_address__c: 'Shipment E-mail',
    shipment_notification_mobile_number__c: 'Shimpent Mobile Number',
    subject: 'Subject',
    description: 'Description',
    cost_centre_number__c: 'Cost Centre Number',
    user__c: 'User',
    user_id__c: 'User ID',
    user_role__c: 'User Role',
    reported_fault_category_2__c: 'Reported Fault Category 2',
    reported_fault_2__c: 'Reported Fault 2',
    reported_fault_category_3__c: 'Reported Fault Category 3',
    reported_fault_3__c: 'Reported Fault 3',
    build_type__c: 'Build Type',
    needed_date__c: 'Needed Date',
    caller_name__c: 'Caller Name',
    callers_phone_number__c: "Caller's Phone Number",
    primary_contact_email_address__c: 'Primary Contact E-mail Address',
    secondary_contact_email_address__c: 'Secondary Contact E-mail Address',
    approved_by__c: 'Approved By',
    lost_or_stolen_approved__c: 'Lost or Stolen Approved',
    approved_date__c: 'Approved Date',
    preferred_collection_date__c: 'Preferred Collection Date',
    affected_sim_number__c: 'Affected SIM Number',
    sim__c: 'SIM',
    ngb_sim_type__c: 'NGB SIM Type',
    sim_card__c: 'SIM Card',
    crime_reference_number__c: 'Crime Reference Number',
    courier__c: 'Courier',
    outbound_tracking__c: 'Outbound Tracking',
    createddate: 'Created Date',
    lastmodifieddate: 'Last Modified Date',
    dispatched_date_time__c: 'Dispatched Date Time',
    expected_dispatch_date__c: 'Expected Dispatch Date',
    signed_for_by__c: 'Signed For By',
    dispatch_delay_s__c: 'Dispatch Delay S',
    reason_for_delay__c: 'Reason For Delay',
    faults_found__c: 'Faults Found',
    resolution__c: 'Resolution',
    closeddate: 'Closed Date',

    ticket_hash: 'Zlecenie #',
    status: 'Status',
    type: 'Typ',
    site: 'Oddział',
    created_by: 'Dodane Przez',
    date_created: 'Data Dodania',
    date_closed: 'Data Zamknięcia',
    view_ticket: 'Wyświetl Zlecenie',
}
  
export default PL